import { trackOnceEvents } from "./trackCustomEvent";

export const getVisitId = () => {
  const stored = localStorage.getItem('visit_session');
  const now = Date.now();
  const sessionDuration = 60 * 60 * 500;

  if (stored) {
    try {
      const { id, timestamp } = JSON.parse(stored);
      if (now - timestamp < sessionDuration) {
        return id;
      }
    } catch (e) {
      // 
    }
  }

  const newId = crypto.randomUUID?.() || Math.random().toString(36).substring(2);
  localStorage.setItem('visit_session', JSON.stringify({ id: newId, timestamp: now }));
  trackOnceEvents.forEach(event => {
    localStorage.setItem(`session_tracked_${event}`, 'false');
  });

  return newId;
};
